const pickerOptions = [
    { id: 1, name: 'Auto Insurance', type: 'auto' },
    { id: 3, name: 'Life Insurance', type: 'life' },
    { id: 2, name: 'Home Insurance', type: 'home' },
    { id: 4, name: 'Medicare Insurance', type: 'health' },
];

export default pickerOptions;
